export { default } from './CourseDetails';



// WEBPACK FOOTER //
// ./src/pages/DataCenter/CourseDetails/index.ts